/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resume_Portfolio_GoInputs */

const en_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go to `)
};

const ar_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اذهب إلى `)
};

const bn_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দেখুন `)
};

const de_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehe zu`)
};

const es_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ir a`)
};

const fr_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aller à`)
};

const pt_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vá para`)
};

const zh_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`转到`)
};

const tr_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Git`)
};

const ru_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к`)
};

const pl_resume_portfolio_go = /** @type {(inputs: Resume_Portfolio_GoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przejdź do`)
};

/**
* | output |
* | --- |
* | "Go to" |
*
* @param {Resume_Portfolio_GoInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const resume_portfolio_go = /** @type {((inputs?: Resume_Portfolio_GoInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resume_Portfolio_GoInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_resume_portfolio_go(inputs)
	if (locale === "bn") return bn_resume_portfolio_go(inputs)
	if (locale === "de") return de_resume_portfolio_go(inputs)
	if (locale === "es") return es_resume_portfolio_go(inputs)
	if (locale === "fr") return fr_resume_portfolio_go(inputs)
	if (locale === "pt") return pt_resume_portfolio_go(inputs)
	if (locale === "zh") return zh_resume_portfolio_go(inputs)
	if (locale === "tr") return tr_resume_portfolio_go(inputs)
	if (locale === "ru") return ru_resume_portfolio_go(inputs)
	if (locale === "pl") return pl_resume_portfolio_go(inputs)
	return en_resume_portfolio_go(inputs)
});